export const visit = (vm, at) => {
at({ "sv": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Har du sv\xE5righeter att se den h\xE4r videon?", "playButton": "Spela upp" } } });
};